<template>
  <div class="mb-3 card ">
    <div
      class="card-header bg-secondary-3 d-flex justify-content-between align-items-center"
    >
      <div>
        Prueba/Muestra Módulo:
        <b>
          {{ value.area.name | empty }}
        </b>
      </div>
      <div>
        <i
          v-if="!isReadOnly"
          class="far fa-times-circle text-danger pointer"
          @click="remove"
        />
      </div>
    </div>
    <div class="card-body bg-secondary-3">
      <div>
        <div class="font-weight-bold">{{ value.area.letter | empty }}</div>
        <div class="data-name">{{ value.area.description | empty }}</div>
      </div>
      <div class="my-3">
        <label class="data-name">Resultados:</label>
        <p v-if="isReadOnly">{{ model.comment | empty }}</p>
        <validation-provider v-else v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
      </div>
      <div class="my-3">
        <label class="data-name">Interpretación:</label>
        <p v-if="isReadOnly">{{ model.interpretation | empty }}</p>
        <validation-provider v-else v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.interpretation"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    remove() {
      this.$emit('remove', this.value);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
